import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Case Studies', path: '/case-studies' },
      { label: 'Careers', path: '/contact' },
      { label: 'Contact', path: '/contact' }
    ],
    services: [
      { label: 'AI & Automation', path: '/services' },
      { label: 'Cloud Solutions', path: '/services' },
      { label: 'Data Analytics', path: '/services' },
      { label: 'Integration', path: '/services' }
    ],
    resources: [
      { label: 'Blog', path: '/blog' },
      { label: 'Industries', path: '/industries' },
      { label: 'How We Work', path: '/how-we-work' },
      { label: 'Vision 2030', path: '/about' }
    ]
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="relative">
                <Sparkles className="w-8 h-8 text-orange-400" />
                <div className="absolute inset-0 bg-orange-400/30 blur-xl" />
              </div>
              <span className="text-2xl font-bold">
                AiFlo<span className="text-orange-400">.ai</span>
              </span>
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              One Platform. Every Enterprise System. AI-Led Execution.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Transforming enterprises with AI-first consulting and software services.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-orange-400/20 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-orange-400/20 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-orange-400/20 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-orange-400 mt-1" />
              <div>
                <p className="text-sm text-gray-400">Email</p>
                <a href="mailto:sales@aiflo.ai" className="text-white hover:text-orange-400 transition-colors">
                  sales@aiflo.ai
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Phone className="w-5 h-5 text-orange-400 mt-1" />
              <div>
                <p className="text-sm text-gray-400">Phone</p>
                <a href="tel:+971544785924" className="text-white hover:text-orange-400 transition-colors">
                  +971 54 478 5924
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-orange-400 mt-1" />
              <div>
                <p className="text-sm text-gray-400">Location</p>
                <p className="text-white">Global Presence</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} AiFlo.ai. All rights reserved. Vision 2030.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors">
              Terms of Service
            </Link>
            <Link to="/cookies" className="text-gray-400 hover:text-orange-400 transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
